module.exports = new __parcel__URL__("filter_avoir.b27bb333.png").toString();